import router from '@/router'

export const namespaced = true

export const state = {
  path: null,
}

export const mutations = {
  SET_PATH(state, modalPath) {
    state.path = modalPath
    // console.log(state.path)
  },
  UNSET_PATH(state) {
    if (state.path.matched.length <= 3) {
      router.push({ name: state.path.matched[1].name })
    } else {
      router.push({ name: state.path.matched[2].name })
    }
    state.path = null
  },
}

export const actions = {
  open({ commit }, modalPath) {
    commit('SET_PATH', modalPath)
  },
  close({ commit }) {
    commit('UNSET_PATH')
  },
}
